import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-start-game',
  imports: [TranslatePipe, MatDialogTitle, MatDialogContent, MatDialogActions,MatButtonModule],
  templateUrl: './confirm-start-game.html',
  styleUrl: './confirm-start-game.scss'
})
export class ConfirmStartGame implements OnInit{
  readonly dialogRef = inject(MatDialogRef<ConfirmStartGame>);
  data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.dialogRef.disableClose = true;
  }

  onNoClick(value: boolean = false): void {
    this.dialogRef.close(value);
  }

  clickIconClose(event: MouseEvent){
    //if(event.layerX > 390 && event.layerX < 417 && event.layerY > 15 && event.layerY < 40){ 
      this.onNoClick();
   // }
  }

}
